function localstorageSetItem (name, value) {
  localStorage.setItem(name, value)
}

function localstorageGetItem (name) {
  return localStorage.getItem(name)
}

function localstorageRemoveItem (name) {
  localStorage.removeItem(name)
}

export {localstorageSetItem, localstorageGetItem, localstorageRemoveItem}




// WEBPACK FOOTER //
// ./src/common/util/localstorageUtil.js